import axios from 'axios'

export default {
  state: {
    toShow: localStorage.getItem('ads-to-show') ? JSON.parse(localStorage.getItem('ads-to-show')) : [],
    expiration: localStorage.getItem('ads-expiration'),
    current: localStorage.getItem('ads-current') ? JSON.parse(localStorage.getItem('ads-current')) : null,
    configuration: localStorage.getItem('ads-configuration') ?
      JSON.parse(localStorage.getItem('ads-configuration')) : null,
    showed: localStorage.getItem('ads-showed') ? JSON.parse(localStorage.getItem('ads-showed')) : [],
    nextAdAvailable: false,
    nextAdAvailableTimerId: null,
    completedView: false,

    expirationTimerId: null,
    sendingShowedAds: false,

    routableId: null,
    clicksLeft: Number(localStorage.getItem('ads-clicks-left') || 0),

    //Intermedios
    intermedios: localStorage.getItem('ads-intermedios') ?
      JSON.parse(localStorage.getItem('ads-intermedios')) : [],
    intPublicaciones: localStorage.getItem('ads-int-publicaciones') ?
      JSON.parse(localStorage.getItem('ads-int-publicaciones')) : {},
    intVistasDifusion: localStorage.getItem('ads-int-vistas-difusion') ?
      JSON.parse(localStorage.getItem('ads-int-vistas-difusion')) : {},
    intExpiration: localStorage.getItem('ads-int-expiration'),
    intExpirationTimerId: null,
    sendingShowedInts: false,
  },
  mutations: {
    SET_TO_SHOW(state, ads) {
      state.toShow = ads
      localStorage.setItem('ads-to-show', JSON.stringify(state.toShow))
    },
    SET_EXPIRATION(state, expiration) {
      state.expiration = expiration
      if (state.expiration) {
        localStorage.setItem('ads-expiration', expiration)
      } else {
        localStorage.removeItem('ads-expiration')
      }
    },
    SET_CONFIGURATION(state, configuration) {
      state.configuration = configuration
      localStorage.setItem('ads-configuration', JSON.stringify(state.configuration))
    },
    SET_CURRENT(state, current) {
      if (state.configuration) {
        state.current = current
        if (current) {
          state.current.showUntil = Date.now() + state.configuration.seconds_per_ad * 1000
          localStorage.setItem('ads-current', JSON.stringify(state.current))
        } else {
          localStorage.removeItem('ads-current')
        }
      }
    },
    ADD_TO_SHOWED(state) {
      if (state.current && !state.current.counted && (state.current.viewed || state.current.clicked)) {
        state.current.counted = true
        localStorage.setItem('ads-current', JSON.stringify(state.current))

        const {id, viewed, clicked, routable_type, routable_id, share_code} = state.current
        state.showed.push({id, viewed, clicked, routable_type, routable_id, share_code})
        localStorage.setItem('ads-showed', JSON.stringify(state.showed))
      }
    },
    ADD_VIEW(state, data) {
      if (state.current && !state.current.viewed) {
        state.current.viewed = true
        state.current.routable_type = data.routableType
        state.current.routable_id = data.routableId
        state.current.share_code = data.shareCode
        localStorage.setItem('ads-current', JSON.stringify(state.current))
        state.completedView = true
        setTimeout(() => {
          state.completedView = false
        }, 3500)
      }
    },
    SET_SHOWED(state, showed) {
      state.showed = showed
      localStorage.setItem('ads-showed', JSON.stringify(state.showed))
    },
    ADD_CLICK(state, data) {
      if (state.current && !state.current.clicked) {
        state.current.clicked = true
        state.current.routable_type = data.routableType
        state.current.routable_id = data.routableId
        state.current.share_code = data.shareCode
        localStorage.setItem('ads-current', JSON.stringify(state.current))

        state.clicksLeft -= 1
        localStorage.setItem('ads-clicks-left', state.clicksLeft)
      }
    },
    SET_NEXT_AD_AVAILABLE(state, bool) {
      state.nextAdAvailable = bool
    },
    SET_COMPLETED_VIEW(state, bool) {
      state.completedView = bool
    },
    SET_NEXT_AD_AVAILABLE_TIMER_ID(state, id) {
      state.nextAdAvailableTimerId = id
    },
    SET_EXPIRATION_TIMER_ID(state, id) {
      state.expirationTimerId = id
    },
    SET_SENDING_SHOWED_ADS(state, bool) {
      state.sendingShowedAds = bool
    },
    SET_ROUTABLE_ID(state, id) {
      state.routableId = id
    },
    SET_CLICKS_LEFT(state, number) {
      state.clicksLeft = number
      localStorage.setItem('ads-clicks-left', state.clicksLeft)
    },

    //Intermedios
    SET_INTERMEDIOS(state, intermedios) {
      state.intermedios = intermedios
      localStorage.setItem('ads-intermedios', JSON.stringify(state.intermedios))
    },
    SET_INT_PUBLICACIONES(state, publicaciones) {
      state.intPublicaciones = publicaciones
      localStorage.setItem('ads-int-publicaciones', JSON.stringify(state.intPublicaciones))
    },
    SET_INT_VISTAS_DIFUSION(state, vistas) {
      state.intVistasDifusion = vistas
      localStorage.setItem('ads-int-vistas-difusion', JSON.stringify(state.intVistasDifusion))
    },
    SET_INT_EXPIRATION(state, exp) {
      state.intExpiration = exp
      if (state.intExpiration) {
        localStorage.setItem('ads-int-expiration', exp)
      } else {
        localStorage.removeItem('ads-int-expiration')
      }
    },
    SET_INT_EXPIRATION_TIMER_ID(state, id) {
      state.intExpirationTimerId = id
    },
    SET_SENDING_SHOWED_INTS(state, bool) {
      state.sendingShowedInts = bool
    },
  },
  actions: {
    async initializeAds({ state, dispatch, commit }) {
      // Reiniciar banderas de que se ha completado la vista del banner y de que el siguiente está disponible
      commit('SET_COMPLETED_VIEW', false)
      commit('SET_NEXT_AD_AVAILABLE', false)

      const unixNow = Date.now()
      if (!state.expiration || state.expiration <= unixNow) {
        // Si no hay fecha de expiración o ya terminó, recuperar el siguiente conjunto de ads
        await dispatch('getAds', true)
      } else if (state.current && state.current.showUntil <= unixNow) {
        // Si hay un banner actual y ya está disponible el siguiente, mover al siguiente banner
        await dispatch('nextAd')
      } else if (state.toShow && state.toShow.length > 0) {
        // Si hay banners siguientes, iniciar timer para poder cambiar al siguiente
        await dispatch('setNextAvailableTimer')
      } else {
        // De lo contrario, iniciar timer para el tiempo de expiración, donde al cumplirse se recupera el siguiente
        // conjunto de ads
        await dispatch('setExpirationTimer')
      }
    },
    async freezeAds({ state, commit }) {
      if (state.nextAdAvailableTimerId) {
        clearTimeout(state.nextAdAvailableTimerId)
        commit('SET_NEXT_AD_AVAILABLE_TIMER_ID', null)
      }
      if (state.expirationTimerId) {
        clearTimeout(state.expirationTimerId)
        commit('SET_EXPIRATION_TIMER_ID', null)
      }
    },
    async getAds({ state, commit, getters, dispatch }, changeCurrent) {
      // Mandar estadísticas de ads ya vistas/con click
      await dispatch('sendShowedAds')

      // Recuperar nuevo conjunto de ads, determinar si hay que cambiar el banner actual
      let currentChanged = false
      await axios.get(`api/v2/ads.json`, {
        params: {
          region_id: getters.localizacion ? getters.localizacion.id_muni : null
        }
      }).then(response => {
        commit('SET_CONFIGURATION', response.data.config)
        commit('SET_CLICKS_LEFT', response.data.clicks_left)
        commit('SET_EXPIRATION', Date.now() + state.configuration.period_seconds * 1000)

        const ads = response.data.ads
        if (changeCurrent || !state.current) {
          commit('SET_CURRENT', ads.pop())
          currentChanged = true
        }
        commit('SET_TO_SHOW', ads)
      })

      // Inicializar timers o poner que hay una siguiente ad disponible
      if (state.current && state.toShow && state.toShow.length > 0) {
        if (currentChanged) {
          dispatch('setNextAvailableTimer')
        } else {
          commit('SET_NEXT_AD_AVAILABLE', true)
        }
      } else {
        dispatch('setExpirationTimer')
      }
    },
    async nextAd({ state, commit, dispatch }) {
      // Añadir banner actual a los mostrados
      commit('ADD_TO_SHOWED')
      if (state.toShow && state.toShow.length > 0) {
        // Establecer el nuevo banner actual
        commit('SET_CURRENT', state.toShow.pop())
        localStorage.setItem('ads-to-show', JSON.stringify(state.toShow))

        if (state.current && state.toShow && state.toShow.length > 0) {
          // Si existe el banner actual y hay más ads por mostrar, iniciar el timer para el siguiente banner
          dispatch('setNextAvailableTimer')
        } else {
          // De lo contrario, iniciar el timer para el tiempo de expiración
          dispatch('setExpirationTimer')
        }
      } else {
        dispatch('setExpirationTimer')
      }
    },
    async sendShowedAds({ state, commit }) {
      if (!state.sendingShowedAds) {
        commit('SET_SENDING_SHOWED_ADS', true)

        commit('ADD_TO_SHOWED')
        if (state.showed.length > 0) {
          await axios.post(`api/v2/ads/count-impressions.json`, {
            ads: state.showed
          }).then(response => {
            if (response.data.ok) {
              commit('SET_SHOWED', [])
            }
          }).catch(() => {})
        }

        commit('SET_SENDING_SHOWED_ADS', false)
      }
    },
    async setNextAvailableTimer({state, commit}) {
      commit('SET_NEXT_AD_AVAILABLE_TIMER_ID', setTimeout(() => {
        commit('SET_NEXT_AD_AVAILABLE_TIMER_ID', null)
        commit('SET_NEXT_AD_AVAILABLE', true)
      }, state.current.showUntil - Date.now()))
    },
    setExpirationTimer({state, commit, dispatch}) {
      const unixNow = Date.now()
      const waitMills = Math.max(state.expiration - unixNow, state.configuration.seconds_per_ad * 1000)

      commit('SET_EXPIRATION_TIMER_ID', setTimeout(() => {
        commit('SET_EXPIRATION_TIMER_ID', null)
        dispatch('getAds',false)
      }, waitMills))
    },
    async explicitLogoutActions({commit}) {
      commit("SET_EXPIRATION", null)
      commit("SET_INT_EXPIRATION", null)
    },

    //Intermedios
    async initializeIntermedios({ state, dispatch }) {
      const unixNow = Date.now()
      if (!state.intExpiration || state.intExpiration <= unixNow) {
        await dispatch('getIntermedios', true)
      } else if (!state.intExpirationTimerId) {
        const waitMills = Math.max(
          state.intExpiration - unixNow, state.configuration.seconds_per_ad * 1000
        )
        await dispatch('setIntExpirationTimer', waitMills)
      }
    },
    async getIntermedios({ getters, dispatch, commit, state }) {
      await dispatch('sendShowedIntermedios')

      await axios.get(`api/v2/ads/intermedios.json`, {
        params: {
          region_id: getters.localizacion ? getters.localizacion.id_muni : null
        }
      }).then(response => {
        commit('SET_CONFIGURATION', response.data.config)
        commit('SET_INT_PUBLICACIONES', response.data.publicaciones)
        dispatch('checkReactions', {tipo: 'publicaciones', ids: Object.keys(response.data.publicaciones)})
        commit('SET_INT_VISTAS_DIFUSION', response.data.vistas_difusion)

        commit('SET_INT_EXPIRATION', Date.now() + state.configuration.period_seconds * 1000)
        commit('SET_INTERMEDIOS', response.data.intermedios)
      })
    },
    setIntExpirationTimer({state, commit, dispatch}, waitMills) {
      clearTimeout(state.intExpirationTimerId)
      commit('SET_INT_EXPIRATION_TIMER_ID', setTimeout(() => {
        commit('SET_INT_EXPIRATION_TIMER_ID', null)
        dispatch('getIntermedios')
      }, waitMills))
    },
    freezeIntermedios({ state, commit }) {
      if (state.intExpirationTimerId) {
        clearTimeout(state.intExpirationTimerId)
        commit('SET_INT_EXPIRATION_TIMER_ID', null)
      }
    },
    addIntermedioView({ state, dispatch }, data) {
      const intermedio = state.intermedios.find(i => i.id === data.id)
      if (intermedio && !intermedio.viewed) {
        intermedio.viewed = true
        intermedio.routable_type = data.routableType
        intermedio.routable_id = data.routableId
        intermedio.share_code = data.shareCode
        localStorage.setItem('ads-intermedios', JSON.stringify(state.intermedios))

        if (!state.intExpirationTimerId) {
          const waitMills = Math.max(
            state.intExpiration - Date.now(), state.configuration.seconds_per_ad * 1000
          )
          dispatch('setIntExpirationTimer', waitMills)
        }
      }
    },
    addIntermedioClick({ state, commit, dispatch }, data) {
      const intermedio = state.intermedios.find(i => i.id === data.id)
      if (intermedio && !intermedio.clicked) {
        intermedio.clicked = true
        intermedio.routable_type = data.routableType
        intermedio.routable_id = data.routableId
        intermedio.share_code = data.shareCode
        localStorage.setItem('ads-intermedios', JSON.stringify(state.intermedios))
        commit('SET_CLICKS_LEFT', state.clicksLeft - 1)

        if (!state.intExpirationTimerId) {
          const waitMills = Math.max(
            state.intExpiration - Date.now(), state.configuration.seconds_per_ad * 1000
          )
          dispatch('setIntExpirationTimer', waitMills)
        }
      }
    },
    async sendShowedIntermedios({ state, commit }, partial = false) {
      if (!state.sendingShowedInts) {
        commit('SET_SENDING_SHOWED_INTS', true)

        const showedIntermedios = []
        const unshowedIntermedios = []
        state.intermedios.forEach(int => {
          if (int.viewed || int.clicked) {
            const {id, viewed, clicked, routable_type, routable_id, share_code} = int
            showedIntermedios.push({id, viewed, clicked, routable_type, routable_id, share_code})
          } else {
            unshowedIntermedios.push(int)
          }
        })
        if (showedIntermedios.length > 0) {
          await axios.post(`api/v2/ads/intermedios-count-impressions.json`, {
            intermedios: showedIntermedios
          }).catch(() => {})
        }

        if (partial) {
          if (unshowedIntermedios.length < state.intermedios.length) {
            commit('SET_INTERMEDIOS', unshowedIntermedios)
          }
        } else {
          commit('SET_INTERMEDIOS', [])
        }

        commit('SET_SENDING_SHOWED_INTS', false)
      }
    },
  },
  getters: {
    currentAd: state => state.current,
    nextAdAvailable: state => state.nextAdAvailable,
    completedView: state => state.completedView,
    routableId: state => state.routableId,
    thereAreClicksLeft: state => state.clicksLeft > 0,

    //Intermedios
    allIntermedios: state => state.intermedios,
    intermediosToShow: state => () => {
      const array = state.intermedios.filter(int => !int.viewed || (int.clickable && !int.clicked))
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]
      }
      return array
    },
    intPublicacion: state => (id) => state.intPublicaciones[id],
    intVistasDifusion: state => (id) => state.intVistasDifusion[id],
  },
}